import { Component } from '@angular/core';
import { AnyoTableComponent } from 'projects/app-core/src/app/models/AnyoTableComponent';
import { EmailTemplateHistoryGridRequest } from '../../../models/email-templates/emailTemplatesHistoryGridRequest';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import { EmailTemplatesService } from '../../../services/email-templates.service';
import { EmailTemplatesHistoryData } from '../../../models/email-templates/emailTemplatesHistoryGridResponse';
import { UtilsService } from 'projects/app-core/src/service/utils.service';
import { IAnyoError } from 'projects/app-core/src/models/errorModal';
import { ActivatedRoute } from '@angular/router';
import { IAnyoUser } from 'projects/app-core/src/auth/models/IAnyoUser';
import { AnyoSortDirection } from 'projects/app-core/src/models/gridRequest';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrl: './logs.component.scss',
})
export class LogsComponent extends AnyoTableComponent<
  EmailTemplatesHistoryData,
  EmailTemplateHistoryGridRequest
> {
  constructor(
    protected override auth: AuthService,
    protected override toastService: ToastService,
    private emailTemp: EmailTemplatesService,
    public utils: UtilsService,
    private activatedRoute: ActivatedRoute,
  ) {
    super(auth, toastService);
  }
  globalSearchInput = '';
  templateId = '';
  override async ready(user?: IAnyoUser): Promise<void> {
    if (user) {
      this.activatedRoute.queryParams.forEach((data) => {
        this.templateId = data['templateId'];
      });
      this.gridRequest.filters = {
        TEMPLATE_ID: [this.templateId],
        PARTNER_ID: undefined,
      };
      this.getData();
    }
  }
  override async getData(): Promise<void> {
    this.pageLoading = true;
    this.emailTemp.getEmailtemplatesLogsGrid(this.gridRequest).subscribe({
      next: (value) => {
        this.totalCount = value.totalRecords;
        this.data = value.data;
        this.pageLoading = false;
      },
      error: (err) => {
        const errorBody = err as { error: IAnyoError };
        this.toastService.showAnyoErrorToast(errorBody.error.description);
        this.pageLoading = false;
      },
    });
  }

  searchGlobal() {
    this.gridRequest.globalSearch = [this.globalSearchInput];
    this.getData();
  }

  override async resetFilter(): Promise<void> {
    this.globalSearchInput = '';
    this.dateRangeColumn = [];
    this.gridRequest = {
      page: this.pageNo,
      pageSize: this.pageSize,
      export: false,
    };
    await this.getData();
  }

  async totalSendSort($event: string | null) {
      this.gridRequest!.sort = {
        TOTAL_SEND: undefined,
      };
  
      if ($event) {
        this.gridRequest!.sort!.TOTAL_SEND =
          $event === 'ascend' ? AnyoSortDirection.ASC : AnyoSortDirection.DESC;
      } else {
        this.gridRequest!.sort!.TOTAL_SEND = AnyoSortDirection.ASC;
      }
      await this.getData();
    }
}
